import {Link, StaticQuery, graphql} from 'gatsby'
import Img from 'gatsby-image'
import React from 'react'
import Icon from './icon'
import {cn} from '../lib/helpers'

import styles from './header.module.css'
import Container from "./container";

const Header = ({onHideNav, onShowNav, showNav, siteTitle}) => (
  <StaticQuery
    query={query}
    render={data => (
      <Container>
        <div className={styles.root}>
          <div className={styles.logo}>
            <Link to="/">
              <Img fluid={data.logo.childImageSharp.fluid} alt="Chooose"/>
            </Link>
          </div>
          <div className={styles.wrapper}>
            {/*<div className={styles.branding}>*/}
            {/*  <Link to='/'>{siteTitle}</Link>*/}
            {/*</div>*/}
            <div className={styles.subcategories}>
              <div className={styles.branding}>
                <Link to='/'>{siteTitle}</Link>
              </div>
            </div>


            {/*<nav className={cn(styles.nav, showNav && styles.showNav)}>*/}
            {/*  <ul>*/}
            {/*    <li>*/}
            {/*      <Link to='/archive/'>Archive</Link>*/}
            {/*    </li>*/}
            {/*  </ul>*/}
            {/*</nav>*/}
          </div>
        </div>
      </Container>
    )}
  />
)

export default Header

const query = graphql`
  query {
    logo: file(relativePath: { eq: "images/CHOOOSE pink dark.png" }) {
      childImageSharp {
        fluid(maxWidth: 600) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`
